var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackChevronPresentationVideo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9501_4962)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#25282D",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4822 10.4102L13.9753 14.6901C13.3493 15.3123 13 16.1396 13 17C13 17.8604 13.3493 18.6877 13.9753 19.3099L18.4822 23.5898C18.7588 23.8525 19.1339 24 19.5251 24C19.9163 24 20.2914 23.8525 20.568 23.5898C20.8446 23.3272 21 22.971 21 22.5996C21 22.2282 20.8446 21.8721 20.568 21.6094L16.0602 17.3294C15.968 17.2419 15.9163 17.1233 15.9163 16.9995C15.9163 16.8758 15.968 16.7571 16.0602 16.6696L20.568 12.3906C20.8446 12.1279 21 11.7718 21 11.4004C21 11.029 20.8446 10.6728 20.568 10.4102C20.2914 10.1475 19.9163 10 19.5251 10C19.1339 10 18.7588 10.1475 18.4822 10.4102Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9501_4962"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackChevronPresentationVideo);
export default __webpack_public_path__ + "static/media/back-chevron-presentation-video.6e51bb8b6ddf00ede1e2cf4832866bd3.svg";
export { ForwardRef as ReactComponent };